import React from 'react';

import CustomButton from 'components/partials/custom-button/custom-button';

import Icons from 'assets/icons';

const commonStyles = 'pl-4 border-r-2 border-white font-semibold h-12';

export const getGoalCriticalElementsTableSettings = (handleViewDetails) => [
  {
    id: 'summary',
    accessorKey: 'summary',
    header: () => <span>CRITICAL ELEMENT</span>,
    cell: (info) => <span>{info.renderValue()}</span>,
    headerClassName: `${commonStyles} rounded-tl-md rounded-bl-md`,
    className: 'pl-4 py-3 tablet:w-[75%] font-semibold',
    enableSorting: false,
  },
  {
    id: 'actions',
    accessorKey: 'id',
    header: () => <span>ACTION</span>,
    isHeaderCentered: true,
    cell: (info) => (
      <div className="flex justify-center">
        <CustomButton
          variant="secondary"
          size="sm"
          iconBefore={<Icons.Eye alt="EyeIcon" height="100%" width="14" />}
          customClass="text-xs md:text-sm"
          onClick={() => handleViewDetails(info.getValue())}
        >
          View Details
        </CustomButton>
      </div>
    ),
    headerClassName: `${commonStyles} rounded-tr-md rounded-br-md`,
    className: 'pl-4 py-3 tablet:w-[20%]',
    enableSorting: false,
  },
];
